export default __webpack_public_path__ + "static/media/4.2d027fff.png";